
    var riot = require('riot')
    //src: starling/src/tags/perspectives-listing-item.html
riot.tag2('perspectives-listing-item',
  '<i if="{!canvas.isViewOnly()}" class="side-tab_item_drag-indicator material-icons">drag_indicator</i> <input ref="checkbox" type="checkbox"> <i ref="perspectivePointIcon" class="side-tab_item_icon material-icons" riot-style="color: {color};">visibility</i> <h4 onclick="{handleTitleClick}" onkeydown="{checkBlurKey}" onblur="{editTitle}" onkeyup="{handleInput}" class="side-tab_item_label perspective-title focusable" ref="label" placeholder="Untitled perspective"></h4> <button hide="{canvas.isViewOnly()}" ref="menuButton" class="context-menu side-tab_item_menu floating-menu_button" onclick="{toggleToolMenu}"> <svg class="floating-menu_button_icon"> <use xlink:href="#more-vert-icon"></use> </svg> </button>',
  '',
  'data-id="{id}" class="side-tab_item perspective-item {isPersisted() && \'persisted\'}" ref="main" title="{getTitle()}" onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseLeave}" onclick="{handleClick}" ondblclick="{startEditing}"', function(opts) {
'use strict';

var _this = this;

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _perspectivesUi = require('lib/perspectives-ui');

var _perspectiveCreationUi = require('lib/perspective-creation-ui');

var _constants = require('lib/constants');

var _util = require('lib/util');

var _richText = require('lib/rich-text');

var _richText2 = _interopRequireDefault(_richText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.canvas = this.opts.canvas;
this.perspective = _store_instance2.default.getPerspective(this.id);
this.editing = false;

this.on('updated', function () {
  // if the sidebar was closed, and then our perspective was activated from
  // a card, we need to re-set some styles when the sidebar is opened.
  if (_this.isActive()) {
    _perspectivesUi.pui.refreshListingItemActivation(_this.perspective, _this.isPersisted());
  }
});
this.on('mount', function () {
  _this.refs.label.innerHTML = _this.getRichTitle();
});
this.handleMouseEnter = function () {
  if (_this.perspective.getPointNode()) {
    _perspectiveCreationUi.pcui.highlightSelectedResultNode(_this.perspective.getPointNode());
  }
  if (_this.editing) return;
  if (_perspectivesUi.pui.perspectiveIsActive(_this.perspective.id)) {
    return;
  }

  _perspectivesUi.pui.setHoverState(_this.perspective);
};

this.handleMouseLeave = function () {
  _perspectiveCreationUi.pcui.clearSelectedResultNode();
  if (_this.editing) return;

  _perspectivesUi.pui.unsetHoverState();
};

this.isActive = function () {
  return _perspectivesUi.pui.perspectiveIsActive(_this.perspective.id);
};

this.isPersisted = function () {
  return _perspectivesUi.pui.perspectiveIsPersistent(_this.perspective.id);
};

this.toggleToolMenu = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
  if (_this.toolMenuOpened && _this.canvas.perspectivesListingItemToolMenuTag.summoned) {
    _this.canvas.perspectivesListingItemToolMenuTag.hide();
    _this.toolMenuOpened = false;
  } else {
    _this.canvas.hidePopups();
    _this.canvas.perspectivesListingItemToolMenuTag.summon(_this);
    _this.toolMenuOpened = true;
    _this.root.classList.add('menu-open');
  }
};

this.editTitle = function (e) {
  e.preventDefault();
  e.stopPropagation();
  _this.refs.label.blur();

  var _richText$encode = _richText2.default.encode(_this.refs.label.innerHTML.trim()),
      title = _richText$encode.text,
      meta = _richText$encode.meta;

  _perspectivesUi.pui.editPerspectiveTitle({
    perspectiveUUID: _this.id,
    title: title,
    meta: meta
  });
  _this.stopEditing();
  _perspectivesUi.pui.refreshPerspectiveLists();
};

/* force title to refresh when undoing a title change */
this.refreshTitle = function () {
  _this.refs.label.innerHTML = _this.getRichTitle();
};

this.checkBlurKey = function (e) {
  var ENTER = _constants.KEY_CODES.ENTER,
      ESCAPE = _constants.KEY_CODES.ESCAPE;

  if (e.keyCode == ENTER) {
    e.preventDefault();
    window.getSelection().empty();
    // if an autocomplete result is selected and enter is pressed, then submit that result
    if (_this.canvas.perspectiveAutocomplete.getSelectedResult()) {
      _this.canvas.perspectiveAutocomplete.handleUpdatePerspectivePoint(e);
      return;
    }

    _this.editTitle(e);
    _this.canvas.hidePopups();
  } else if (e.keyCode == ESCAPE) {
    e.preventDefault();
    if (_this.getTitle() == '') {
      _perspectivesUi.pui.deletePerspective(_this.id);
      _perspectivesUi.pui.refreshPerspectiveLists();
      _this.canvas.perspectiveAutocomplete.hide();
      return;
    }
    window.getSelection().empty();
    _this.revertTitle(e);
    _this.canvas.hidePopups();
  }
};

this.revertTitle = function () {
  var oldTitle = _this.getRichTitle();
  _this.refs.label.innerHTML = oldTitle;
  _this.stopEditing();
  _this.refs.label.blur();
  _this.update();
};

this.startEditing = function (e) {
  if (_this.canvas.isViewOnly()) {
    return;
  }
  _this.editing = true;
  _this.refs.label.contentEditable = true;
  _this.canvas.perspectivesListingTag.editing = true;
  _this.refs.label.focus();
  (0, _util.selectElementContents)(_this.refs.label);
  _this.root.classList.add('editing');

  if (!_this.perspective.pointNodeUUID) {
    // autocomplete card names only if the current P doesn't have a card in map
    _this.canvas.perspectiveAutocomplete.summon({
      perspective: _this.perspective,
      element: _this.refs.label,
      done: function done() {
        _this.stopEditing();
      }
    });
  }
};

this.stopEditing = function () {
  if (!_this.editing) {
    return;
  }
  _this.editing = false;
  _this.refs.label.contentEditable = false;
  _this.root.classList.remove('editing');
  _this.canvas.perspectiveAutocomplete.hide();
};

this.handleClick = function (e) {
  _this.canvas.perspectivesListingItemToolMenuTag.hide();
  if (_this.editing) {
    _this.stopEditing();
    return;
  }
  if (!_perspectivesUi.pui.getPersistentPerspectiveCount()) {
    _perspectivesUi.pui.setActivePerspective(_this.perspective, true);
  } else if (e.shiftKey) {
    if (_perspectivesUi.pui.perspectiveIsPersistent(_this.perspective.id)) {
      _perspectivesUi.pui.unsetActivePerspective(_this.perspective);
    } else {
      _perspectivesUi.pui.setMultipleActivePerspective(_this.perspective, true);
    }
  } else if (_perspectivesUi.pui.perspectiveIsPersistent(_this.perspective.id)) {
    _perspectivesUi.pui.unsetActivePerspective(_this.perspective);
  } else {
    _perspectivesUi.pui.unsetAllPerspectives();
    _perspectivesUi.pui.setActivePerspective(_this.perspective, true);
  }
};

this.handleTitleClick = function (e) {
  if (_this.editing) {
    e.stopPropagation();
  }
  e.preventDefault();
};

this.setActive = function (isPersisted) {
  if (_this.refs) {
    _this.root.classList.add('active', 'perspective-' + _this.id + '-light-background');
    if (isPersisted) {
      _this.root.classList.add('persisted');
      _this.refs.checkbox.checked = true;
    }
  }
};

this.unsetActive = function (isPersisted) {
  if (_this.refs) {
    _this.root.classList.remove('active', 'perspective-' + _this.id + '-light-background');
    if (isPersisted) {
      _this.root.classList.remove('persisted');
      _this.refs.checkbox.checked = false;
    }
  }
};

this.handleInput = function (e) {
  if (_this.canvas.isViewOnly()) {
    return;
  }
  var titleElement = e.target;
  var title = titleElement.innerText.trim();
  var TAB = _constants.KEY_CODES.TAB,
      DOWN_ARROW = _constants.KEY_CODES.DOWN_ARROW,
      UP_ARROW = _constants.KEY_CODES.UP_ARROW,
      ESCAPE = _constants.KEY_CODES.ESCAPE;

  if (e.keyCode == TAB || e.keyCode == ESCAPE) {
    return;
  }
  if (!e.keyCode) {
    return;
  }

  if (e.keyCode == UP_ARROW) {
    _this.canvas.perspectiveAutocomplete.handleUpKey(e);
    var selectedNode = _this.canvas.perspectiveAutocomplete.getSelectedResult();
    if (selectedNode) {
      titleElement.innerText = selectedNode.getTitle();
    }
    (0, _util.setEndOfContenteditable)(titleElement);
    return;
  }

  if (e.keyCode == DOWN_ARROW) {
    _this.canvas.perspectiveAutocomplete.handleDownKey(e);
    var _selectedNode = _this.canvas.perspectiveAutocomplete.getSelectedResult();
    if (_selectedNode) {
      titleElement.innerText = _selectedNode.getTitle();
    }
    (0, _util.setEndOfContenteditable)(titleElement);
    return;
  }

  _this.canvas.perspectiveAutocomplete.updateResults(title);
  _this.update();
};

this.on('update', function () {
  if (!_this.editing) _this.refs.label.innerHTML = _this.getRichTitle();
  _perspectivesUi.pui.addStyleRules(_this.perspective);
});

_perspectivesUi.pui.addStyleRules(this.perspective);
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('perspectives-listing-item')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/perspectives-listing-item.html
// module id = 657
// module chunks = 0